import { render, staticRenderFns } from "./ConfigureTimeAdmin.vue?vue&type=template&id=05115cae&scoped=true"
import script from "./ConfigureTimeAdmin.vue?vue&type=script&lang=js"
export * from "./ConfigureTimeAdmin.vue?vue&type=script&lang=js"
import style0 from "./ConfigureTimeAdmin.vue?vue&type=style&index=0&id=05115cae&prod&lang=scss&scoped=true"
import style1 from "./ConfigureTimeAdmin.vue?vue&type=style&index=1&id=05115cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05115cae",
  null
  
)

export default component.exports